import React, { useEffect } from "react";
import MemberPartnerDashboardWrapper from "../../../layout/wrapper/MemberPartnerDashboardWrapper";
import { Box, Stack, alpha, styled } from "@mui/system";
import styles from "../../../styles/pages/user/memberpartner/my-videos-approved.module.scss";
import {
  Button,
  List,
  ListItem,
  Menu,
  MenuItem,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import PendingPublicationIcon from "../../../public/assets/icons/PendingPublicationIcon";
import PublishedVideoIcon from "../../../public/assets/icons/PublishedVideoIcon";
import OpenMessageIcon from "../../../public/assets/icons/OpenMessageIcon";
import PerfectScrollbar from "react-perfect-scrollbar";
import EditorDashboardTable from "../../../components/Error/EditorDashboardTable/EditorDashboardTable";
import CalenderIcon from "../../../ui/Icons/CalenderIcon";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import RejectedVideoIcon from "../../../public/assets/icons/RejectedVideoIcon";
import BtnTickIcon from "../../../public/assets/icons/BtnTickIcon";
import RightIcon from "../../../public/assets/icons/RightIcon";
import RightBlackIcon from "../../../ui/Icons/RightBlackIcon";
import ApprovedVideoIcon from "../../../public/assets/icons/ApprovedVideoIcon";
import CopyBlueIcon from "../../../public/assets/icons/CopyBlueIcon";
import CopyIndexIcon from "../../../public/assets/icons/CopyIndexIcon";
import CopyLinkIcon from "../../../public/assets/icons/CopyLinkIcon";
import DuplicateVideoICon from "../../../ui/Icons/DuplicateVideoICon";
import MyVideosApprovedFilter from "../../../components/MemberPartnerDashboardTableFilter/MyVideosApprovedFilter";
import EditorFilter from "../../../components/EditorFilter/EditorFilter";
import EditorPublishTable from "../../../components/EditorPublishTable/EditorPublishTable";
import ApprovedVideoTable from "../../../components/ApprovedvideoTable/ApprovedVideoTable";
import ReviewVideoFilter from "../../../components/ReviewdVideoFilter/ReviewVideoFilter";
import MemberPartnerApprovedVideosTable from "../../../components/MemberPartnerVideoTables/MemberPartnerApprovedVideosTable";
import MemberPartnerPendingVideosTable from "../../../components/MemberPartnerVideoTables/MemberPartnerPendingVideoTable";
import MemberPartnerRejectedVideosTable from "../../../components/MemberPartnerVideoTables/MemberPartnerRejectedVideoTable";
import MemberPartnerDuplicateVideosTable from "../../../components/MemberPartnerVideoTables/MemberPartnerDuplicateVideosTable";
import MyVideosPendingFilter from "../../../components/MemberPartnerDashboardTableFilter/MyVideosPendingFilter";
import MyVideosRejectedFilter from "../../../components/MemberPartnerDashboardTableFilter/MyVidoesRejectedFilter";
import MyVideosDuplicateFilter from "../../../components/MemberPartnerDashboardTableFilter/MyVideosDuplicateFilter";
import { usePost } from "../../../hooks/api/useFetch";
import { useState } from "react";
import { useLocation, useNavigate, useRouter } from "react-router-dom";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const MyVideosApproved = () => {
  const location = useLocation();
  const tabId = Number(new URLSearchParams(location.search).get("tab"));
  const [when_file, setWhenFile] = useState("");

  const [value, setValue] = React.useState(0);

  const [calenderDate, setCalenderDate] = useState({ from: "", to: "" });
  //! --------------------------------
  console.log("CalenderDate", calenderDate);
  //! --------------------------------

  const [dateFilter, setDateFilter] = useState({
    from: "",
    to: "",
  });
  //! --------------------------------
  console.log("DateFilterFilmLocation", dateFilter);
  //! --------------------------------

  const [dateFilter1, setDateFilter1] = useState({
    from: "",
    to: "",
  });
  const [dateFilter2, setDateFilter2] = useState({
    from: "",
    to: "",
  });
  const [dateFilter3, setDateFilter3] = useState({
    from: "",
    to: "",
  });

  const handleDateFilter = (dates) => {
    const { startDate, endDate } = dates;
    setDateFilter({ from: startDate, to: endDate });
  };

  const handleDateFilter1 = (dates) => {
    const { startDate, endDate } = dates;
    setDateFilter1({ from: startDate, to: endDate });
  };

  const handleDateFilter2 = (dates) => {
    const { startDate, endDate } = dates;
    setDateFilter2({ from: startDate, to: endDate });
  };
  const handleDateFilter3 = (dates) => {
    const { startDate, endDate } = dates;
    setDateFilter3({ from: startDate, to: endDate });
  };

  const [videoCountry, setVideoCountry] = useState("");
  const [filterParams, setFilterParams] = useState(null);
  const [filterParams1, setFilterParams1] = useState(null);
  const [filterParams2, setFilterParams2] = useState(null);

  console.warn("filterParams", filterParams);
  const resetFilterparams = () => {
    setFilterParams(null);
    setFilterParams1(null);
    setFilterParams2(null);
    setDateFilter({
      from: "",
      to: "",
    });
    setDateFilter1({
      from: "",
      to: "",
    });
    setDateFilter2({
      from: "",
      to: "",
    });
    setDateFilter3({
      from: "",
      to: "",
    });
    setVideoCountry("");
  };
  const navigate = useNavigate();
  const router = useLocation();
  useEffect(() => {
    const tabs = {
      "#pending": 0,
      "#approved": 1,
      "#rejected": 2,
      "#duplicate": 3,
    };
    handleChange(null, tabs[router.hash]);
  }, [router.hash]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 0) {
      navigate("/member-partner-dashboard/my-videos-approved#pending");
    }
    if (newValue === 1) {
      navigate("/member-partner-dashboard/my-videos-approved#approved");
    }
    if (newValue === 2) {
      navigate("/member-partner-dashboard/my-videos-approved#rejected");
    }
    if (newValue === 3) {
      navigate("/member-partner-dashboard/my-videos-approved#duplicate");
    }
  };

  /*************************************/

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [page, setPage] = useState(1);
  const handlePageChange = (e) => {
    setPage(e);
  };

  const StyledMenu = styled((props) => (
    <Menu
      elevation={0}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      {...props}
    />
  ))(({ theme }) => ({
    "& .MuiPaper-root": {
      borderRadius: 6,
      marginTop: theme.spacing(1),
      minWidth: "auto",
      color:
        theme.palette.mode === "light"
          ? "rgb(55, 65, 81)"
          : theme.palette.grey[300],
      boxShadow:
        "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
      "& .MuiMenu-list": {
        padding: "4px 0",
      },
      "& .MuiMenuItem-root": {
        "&.MuiButtonBase-root": {
          color: "#000",
          fontSize: "14px",
        },
        "& .MuiSvgIcon-root": {
          fontSize: 18,
          color: theme.palette.text.secondary,
          marginRight: theme.spacing(1.5),
        },
        "&:active": {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity
          ),
        },
      },
    },
  }));

  // partnerDataLoad
  const {
    data: managerSubmissionsData,
    isLoading: managerLoading,
    isSuccess: managerSubmissionsIsSuccess,
    isFetching,
  } = usePost(["manager-partner-submissions"], "member_partner/submissions");

  // partnerDataLoad

  const [pendingTotal, setPendingTotal] = useState(null);
  const [approvedTotal, setApprovedTotal] = useState(null);
  const [rejectedTotal, setRejectTotal] = useState(null);
  const [duplicateTotal, setDuplicateTotal] = useState(null);
  console.warn("pendingVideo----", pendingTotal);

  return (
    <MemberPartnerDashboardWrapper>
      <Box className={styles.editorDashboardWrapper}>
        <Box className={styles.editorTab}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              className={styles.pendingItem}
              label={
                <>
                  <Box className={styles.tabItem}>
                    <Box className={styles.tabitemImg}>
                      <PendingPublicationIcon />
                    </Box>

                    <p>
                      Pending Review{" "}
                      {managerSubmissionsData?.data?.data?.submissions
                        ?.pending_videos
                        ? managerSubmissionsData?.data?.data?.submissions
                            ?.pending_videos
                        : "_"}
                    </p>
                  </Box>
                </>
              }
              {...a11yProps(0)}
            />
            <Tab
              className={styles.tabItemApprove}
              label={
                <>
                  <Box className={styles.tabItem}>
                    <Box className={styles.tabitemImg}>
                      <ApprovedVideoIcon color={"#000"} />
                    </Box>
                    <p>
                      Approved Videos{" "}
                      {managerSubmissionsData?.data?.data?.submissions?.approved
                        ? managerSubmissionsData?.data?.data?.submissions
                            ?.approved
                        : "_"}
                    </p>
                  </Box>
                </>
              }
              {...a11yProps(1)}
            />

            <Tab
              className={styles.rejectedItem}
              label={
                <>
                  <Box className={styles.tabItem}>
                    <Box className={styles.tabitemImg}>
                      <RejectedVideoIcon color="#000" />
                    </Box>

                    <p>
                      Rejected Videos{" "}
                      {managerSubmissionsData?.data?.data?.submissions?.rejected
                        ? managerSubmissionsData?.data?.data?.submissions
                            ?.rejected
                        : "_"}
                    </p>
                  </Box>
                </>
              }
              {...a11yProps(2)}
            />

            <Tab
              className={styles.duplicateItem}
              label={
                <>
                  <Box className={styles.tabItem}>
                    <Box className={styles.tabitemImg}>
                      <DuplicateVideoICon color={"#000"} />
                    </Box>
                    <p>
                      Duplicated Videos{" "}
                      {managerSubmissionsData?.data?.data?.submissions
                        ?.duplicate_videos
                        ? managerSubmissionsData?.data?.data?.submissions
                            ?.duplicate_videos
                        : "_"}
                    </p>
                  </Box>
                </>
              }
              {...a11yProps(3)}
            />
          </Tabs>
        </Box>

        <Box className={styles.copywriterBody}>
          <CustomTabPanel value={value} index={0}>
            <Box className={styles.copywriterTabTitling}>
              <Box className={styles.TitlingLeft}>
                <Box className={styles.titlingListItem}>
                  <MyVideosPendingFilter
                    setWhenFile={setWhenFile}
                    when_file={when_file}
                    calenderDate={calenderDate}
                    setCalenderDate={setCalenderDate}
                    setDateFilter={setDateFilter}
                    currentFilterParams={filterParams}
                    videoCountry={videoCountry}
                    setVideoCountry={setVideoCountry}
                    dateFilter={dateFilter}
                    handleDateFilter={handleDateFilter}
                    handleFilter={setFilterParams}
                    filterParams={filterParams}
                    total={pendingTotal}
                  />
                </Box>
                <Box className={styles.approveTableWrapper}>
                  <MemberPartnerPendingVideosTable
                    calenderDate={calenderDate}
                    videoCountry={videoCountry}
                    dateFilter={dateFilter}
                    handlePageChange={handlePageChange}
                    resetFilterparams={resetFilterparams}
                    page={page}
                    filterParams={filterParams}
                    setPendingTotal={setPendingTotal}
                  />
                </Box>
              </Box>
            </Box>
          </CustomTabPanel>

          <CustomTabPanel value={value} index={1}>
            <Box className={styles.copywriterTabTitling}>
              <Box className={styles.TitlingLeft}>
                <Box className={styles.titlingListItem}>
                  <MyVideosApprovedFilter
                    setCalenderDate={setCalenderDate}
                    setDateFilter={setDateFilter1}
                    currentFilterParams={filterParams1}
                    videoCountry={videoCountry}
                    setVideoCountry={setVideoCountry}
                    dateFilter={dateFilter1}
                    handleDateFilter={handleDateFilter1}
                    handleFilter={setFilterParams1}
                    filterParams={filterParams1}
                    total={approvedTotal}
                  />
                </Box>
                <Box className={styles.approveTableWrapper}>
                  <MemberPartnerApprovedVideosTable
                    calenderDate={calenderDate}
                    videoCountry={videoCountry}
                    dateFilter={dateFilter1}
                    handlePageChange={handlePageChange}
                    resetFilterparams={resetFilterparams}
                    page={page}
                    filterParams={filterParams1}
                    setApprovedTotal={setApprovedTotal}
                  />
                </Box>
              </Box>
            </Box>
          </CustomTabPanel>

          <CustomTabPanel value={value} index={2}>
            <Box className={styles.copywriterTabTitling}>
              <Box className={styles.TitlingLeft}>
                <Box className={styles.titlingListItem}>
                  <MyVideosRejectedFilter
                    setCalenderDate={setCalenderDate}
                    setDateFilter={setDateFilter2}
                    currentFilterParams={filterParams2}
                    videoCountry={videoCountry}
                    setVideoCountry={setVideoCountry}
                    dateFilter={dateFilter2}
                    handleDateFilter={handleDateFilter2}
                    handleFilter={setFilterParams2}
                    filterParams={filterParams2}
                    total={rejectedTotal}
                  />
                </Box>
                <Box className={styles.approveTableWrapper}>
                  <MemberPartnerRejectedVideosTable
                    calenderDate={calenderDate}
                    videoCountry={videoCountry}
                    dateFilter={dateFilter2}
                    handlePageChange={handlePageChange}
                    resetFilterparams={resetFilterparams}
                    page={page}
                    filterParams={filterParams2}
                    setRejectTotal={setRejectTotal}
                  />
                </Box>
              </Box>
            </Box>
          </CustomTabPanel>

          <CustomTabPanel value={value} index={3}>
            <Box
              className={`${styles.copywriterTabTitling} ${styles.copywriterTabTitlingDuplicated}`}
            >
              <Box className={styles.TitlingLeft}>
                <Box className={styles.titlingListItem}>
                  <MyVideosDuplicateFilter
                    setCalenderDate={setCalenderDate}
                    setDateFilter={setDateFilter3}
                    total={duplicateTotal}
                  />
                </Box>
                <Box className={styles.approveTableWrapper}>
                  <MemberPartnerDuplicateVideosTable
                    calenderDate={calenderDate}
                    dateFilter={dateFilter3}
                    handlePageChange={handlePageChange}
                    page={page}
                    setDuplicateTotal={setDuplicateTotal}
                  />
                </Box>
              </Box>
            </Box>
          </CustomTabPanel>
        </Box>
      </Box>
    </MemberPartnerDashboardWrapper>
  );
};

export default MyVideosApproved;
